var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentCopy = function SvgContentCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M15.79 3H5.684C4.758 3 4 3.736 4 4.636v11.455h1.684V4.636H15.79zm2.526 3.273H9.053c-.927 0-1.685.736-1.685 1.636v11.455c0 .9.758 1.636 1.685 1.636h9.263c.926 0 1.684-.736 1.684-1.636V7.909c0-.9-.758-1.636-1.684-1.636m0 13.09H9.053V7.91h9.263z"
  })));
};
export default SvgContentCopy;